import type { GenUiTranslate } from './i18n.js';
import { FLIGHT_POLICY_RULE_KEYS } from './flight_policy_rule_keys.js';

const BOOKING_WINDOW_KEYS = new Set(['advance', 'bookingWindow', 'bookingWindowInternational']);

/** O agregado diz QUE reprovou, não por quê: não vira motivo. */
const AGGREGATE_KEYS = new Set(['withinPolicy', 'withinPolitics']);

interface PolicyViolation {
  readonly key: string;
  readonly params?:
    | { readonly days: number; readonly scope: 'domestic' | 'international' }
    | undefined;
}

function lowerFirst(phrase: string, locale: string): string {
  return phrase.charAt(0).toLocaleLowerCase(locale) + phrase.slice(1);
}

/** O motivo de UMA regra, em minúscula para entrar no meio da frase. Regra que a
 *  tabela não conhece (produtor mais novo) não vira motivo: um rótulo cru seria pior
 *  que o aviso genérico. */
function reasonOf(
  violation: PolicyViolation,
  t: GenUiTranslate,
  locale: string,
): string | undefined {
  const { params } = violation;
  if (params && BOOKING_WINDOW_KEYS.has(violation.key)) {
    return t(
      params.days === 1
        ? 'productCheckout.reason.bookingWindow_one'
        : 'productCheckout.reason.bookingWindow_other',
      {
        count: params.days,
        scope: t(
          params.scope === 'domestic'
            ? 'flight.policyRule.scope.domestic'
            : 'flight.policyRule.scope.international',
        ),
      },
    );
  }
  // `Object.hasOwn`: uma chave como `constructor` acharia o protótipo, não uma tradução.
  const titleKey = Object.hasOwn(FLIGHT_POLICY_RULE_KEYS, violation.key)
    ? FLIGHT_POLICY_RULE_KEYS[violation.key]
    : undefined;
  return titleKey ? lowerFirst(t(titleKey), locale) : undefined;
}

/**
 * Os motivos nomeáveis de uma reprovação de política de voo, na ordem e sem repetir —
 * a mesma frase no aviso de justificativa do checkout (#5262) e na linha da família
 * fora da política na escada de tarifas (#5797).
 */
export function flightPolicyReasons(
  violations: readonly PolicyViolation[],
  t: GenUiTranslate,
  locale: string,
): string[] {
  const reasons = new Set<string>();
  for (const violation of violations) {
    if (AGGREGATE_KEYS.has(violation.key)) continue;
    const reason = reasonOf(violation, t, locale);
    if (reason) reasons.add(reason);
  }
  return [...reasons];
}
